// extracted by mini-css-extract-plugin
export default {"catalogItemsContainer":"CatalogItems_catalogItemsContainer__ZKj2a"};